import React from 'react';
import { useState } from 'react'
import PlanRecipes from './PlanRecipes/PlanRecipes'
import PlanIngredients from './PlanIngredients/PlanIngredients'
import { useData } from "../../DataContext/DataProvider"
import "./PlannerElementMax.css"

function PlannerElementMax({ activeDate}) {
    const [showPlannedIngredients, setShowPlannedIngredients] = useState(false)
    const [selectedRecipeIndex, setSelectedRecipeIndex] = useState(0)
  
    const planData = useData().planData.plans.filter((plan) => plan.Plan_Date.getTime() === activeDate.getTime());
    const dataContext = useData();
    
    function handleViewIngredients(index) {
        setSelectedRecipeIndex(index)
        setShowPlannedIngredients(true)
    }

    function handleHideIngredients(e) {
        e.preventDefault()
        setShowPlannedIngredients(false)
    }
    /*
    * @param {any} highlightedIngredient : {
    * Ingredient_Name
    * Ingredient_Quantity
    * Plan_Date
    * Plan_ID
    * Recipe_ID
    * Recipe_Ingredient_ID
    * Recipe_Name
    * }
    * @param {any} listIngredient
    */
    const handlePair = (highlightedIngredient, listIngredient) => {
        dataContext.planData.handlePlanIngredientPair({
            ...highlightedIngredient,
            Plan_ID: planData[selectedRecipeIndex].Plan_ID,
            Plan_Date: activeDate
        }, listIngredient)
    }

    var elementDateString = activeDate.toLocaleDateString('default', { day: 'numeric', weekday: 'long' })
    switch (activeDate.getDate() % 10){
        case 1:
            elementDateString += "st"
            break;
        case 2:
            elementDateString += "nd"
            break;
        case 3:
            elementDateString += "rd"
            break;
        default:
            elementDateString += "th"
            break;
    }

    return (
        <div className="planner-page-element active-date-container column">
            <p>{elementDateString}</p>
            <div className="row">
                <PlanRecipes
                    planData={planData}
                    handleViewIngredients={handleViewIngredients}
                    isActive={!showPlannedIngredients}
                    activeDate={activeDate }
                />
                <PlanIngredients
                    recipe={planData[selectedRecipeIndex] ?? []}
                    isActive={showPlannedIngredients}
                    handlePair={handlePair}
                    backHandler={handleHideIngredients}
                />
            </div>
        </div>
    )
}

export default PlannerElementMax;